// autofocus.directive.js
"use strict";

autofocusDirective.$inject = ["$timeout"];

function autofocusDirective($timeout) {
  return {
    link: function ( scope, element, attrs ) {
        scope.$watch( attrs.inetumAutofocus, function ( val ) {
            if ( angular.isDefined( val ) && val ) {
                $timeout( function () { element[0].focus(); } );
            }
        }, true);
    }
  };
}

export { autofocusDirective };
